import MuiDrawer from "@mui/material/Drawer";
import Grid from "@/config/Grid/Grid";
import CategoryTile from "../CategoryTile/CategoryTile";
import IconButton from "../IconButton/IconButton";
import { drawerStyles } from "../Drawer/Drawer.styles";
import drawerCss from "../Drawer/Drawer.module.scss";
import styles from "./MenuTypeDrawer.module.scss";

export interface MenuTypeOption {
  id: string;
  name: string;
  subtitle?: string;
  /** The menu type's own photo, once the backend carries one. */
  imageUrl?: string;
}

interface MenuTypeDrawerProps {
  open: boolean;
  title: string;
  options: MenuTypeOption[];
  onSelect: (id: string) => void;
  onClose: () => void;
}

/**
 * Switches between menu types without walking back to the menu's front page.
 *
 * The same tiles the front page shows, in a sheet, so the guest can jump from
 * breakfast to drinks from wherever they are in the list.
 */
function MenuTypeDrawer(props: MenuTypeDrawerProps) {
  const { open, title, options, onSelect, onClose } = props;

  return (
    <MuiDrawer sx={drawerStyles} anchor="bottom" open={open} onClose={onClose}>
      <Grid>
        <div
          className={`start-1 col-4 align-start ${drawerCss.drawerLayoutWrapper}`}
        >
          <div className={drawerCss.drawerLayoutHeader}>
            <IconButton
              iconName="las la-angle-left icon-big"
              onClick={onClose}
              color="primary"
            />
            <p className={`body-bold-large ${drawerCss.drawerLayoutTitle}`}>
              {title}
            </p>
            <IconButton
              iconName=""
              onClick={() => {}}
              color="primary"
              variant="text"
            />
          </div>

          <div className={styles.menuTypeGrid}>
            {options.map((option) => (
              <CategoryTile
                key={option.id}
                name={option.name}
                subtitle={option.subtitle}
                imageUrl={option.imageUrl}
                onClick={() => onSelect(option.id)}
              />
            ))}
          </div>
        </div>
      </Grid>
    </MuiDrawer>
  );
}

export default MenuTypeDrawer;
